import { HealthCategoryDataOptionsContract } from '../types/contracts';

export const getPlanTypeId = (planCategoryDataOptions: HealthCategoryDataOptionsContract): string => {
    return planCategoryDataOptions?.typeId || '';
};
